import React, { useState } from "react";
import {
  Box,
  Card,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import {
  ButtonComponent,
  CheckboxComponent,
  InputComponent,
  RadioButtonComponent,
  DropdownComponent,
} from "../../atoms";
import _ from "lodash";
import AddressCard from "./AddressCard";
import { getChecked } from "../../../utils/Credentials";
import { IMAGES } from "../../../assets";

export const ShippingDetailsCard = ({
  shippingCost = 0,
  shippingCharge = 0,
  otherOptions = [],
  paymentMethods = [],
  handleAdditionalCost = () => {},
  onChangePromo = () => {},
  check,
  setCheck = () => {},
  promoValue,
  onClickCheck = () => {},
  isDiscount = false,
  promoCodeError = false,
  promoCodeErrorMessage = "",
  promotion = {},
  radioButton,
  handleChangeRadio=()=>{},
  lateFee = 0,
  lateDetails = [],
  isCheckDisabled = false,
  handleShipmentSubmit = () => {},
  shipBtnName = "",
  shipBtnIsDisabled = false,
  addressList = [],
  onChangeAddress = () => {},
  addressId,
  addressDetails=[],
  checkTerms,
  handleChangeTermsCheckbox = () => {},
}) => {
  const roundToDecimalPlace = (number, decimalPlaces) => {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(number * factor) / factor;
  };

  const getLateDaysSum = () => {
    const totalLateDays = lateDetails.reduce((sum, item) => {
      return sum + (item.lateDays || 0); // Add lateDays if it exists, otherwise add 0
    }, 0);
    return totalLateDays;
  };

  function formatString(input) {
    return input
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
  }

  return (
    <Card sx={{ p: 1 }}>
      <Box>
        <Typography
          textAlign={"center"}
          fontFamily={"Source Sans Pro"}
          fontWeight={600}
          variant="subtitle1"
        >
          Shipping Details & Options
        </Typography>
      </Box>
      <Divider />
      <Container>
        <Stack spacing={2} p={1}>
          <Box>
            <Box>
              <Typography
                fontWeight={600}
                fontFamily={"Source Sans Pro"}
                variant="subtitle1"
              >
                Shipping Method & Cost
              </Typography>
            </Box>
            <Grid container alignItems={"center"}>
              <Grid item xs={8}>
                <Box>
                  <RadioButtonComponent
                    selectedValue={"fed_ex"}
                    value={"fed_ex"}
                    name={"shippingMethod"}
                    label={"FedExEconomy"}
                  />
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box>
                  <Typography
                    textAlign={"right"}
                    fontWeight={600}
                    fontSize={14}
                    fontFamily={"Source Sans Pro"}
                    variant="subtitle1"
                  >
                    ${roundToDecimalPlace(shippingCharge, 2)}
                  </Typography>
                </Box>
              </Grid>
              {lateFee > 0 ? (<>
              <Grid item xs={8}>
              <Box>
                <RadioButtonComponent
                  label={`Late Charges - For ${getLateDaysSum()} days`}
                />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box>
                <Typography
                  textAlign={"right"}
                  fontWeight={600}
                  fontSize={14}
                  fontFamily={"Source Sans Pro"}
                  variant="subtitle1"
                >
                  ${roundToDecimalPlace(lateFee, 2)} 
                </Typography>
              </Box>
            </Grid>
            </>):''}
              
            </Grid>
          </Box>
          {_.map(otherOptions, (item, index) => {
            return (
              <Box key={index + 1}>
                <Box>
                  <Typography
                    fontWeight={600}
                    fontFamily={"Source Sans Pro"}
                    variant="subtitle1"
                  >
                    {formatString(_.get(item, "charge_group"))}
                  </Typography>
                </Box>
                {_.map(_.get(item, "charge_list"), (charge, index) => {
                  return (
                    <Grid container alignItems={"center"} key={index + 1}>
                      <Grid item xs={8}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <CheckboxComponent
                            value={check ? 0 : 1}
                            onChange={(e) =>
                              handleAdditionalCost(e.target.checked, {
                                description: _.get(charge, "title"),
                                charge: _.get(charge, "cost"),
                                code: _.get(charge, "myus_parameter"),
                              })
                            }
                          />
                          <Typography
                            variant="subtitle1"
                            fontFamily={"Source Sans Pro"}
                          >
                            {_.get(charge, "title")}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={4}>
                        <Box>
                          <Typography
                            textAlign={"right"}
                            fontWeight={600}
                            fontFamily={"Source Sans Pro"}
                            variant="subtitle1"
                          >
                            ${_.get(charge, "cost")}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  );
                })}
              </Box>
            );
          })}

          {/* <Box>
            <Box>
              <Typography
                fontWeight={600}
                fontFamily={"Source Sans Pro"}
                variant="subtitle1"
              >
                Payment Method
              </Typography>
            </Box>
            <Grid container alignItems={"center"}>
              <Grid item xs={8}>
                {_.map(paymentMethods, (item, index) => {
                  return (
                    <Box key={index + 1}>
                      <RadioButtonComponent
                        name={"payment"}
                        selectedValue={radioButton}
                        value={_.get(item, "id")}
                        label={_.get(item, "slug")}
                        image={_.get(item, "image")}
                        handleChange={() => handleChangeRadio(_.get(item, "id"))}
                      />
                    </Box>
                  );
                })}
              </Grid>
            </Grid>
          </Box> */}
          <Divider />

          <Box>
            <Box>
              <Typography
                fontWeight={600}
                fontFamily={"Source Sans Pro"}
                variant="subtitle1"
              >
                Check Discount
              </Typography>
            </Box>
            <Grid
              container
              sx={{ display: "flex", alignItems: "flex-start" }}
              spacing={1}
              pt={1}
            >
              <Grid item xs={8}>
                <InputComponent
                  isError={promoCodeError}
                  error={promoCodeErrorMessage}
                  pro
                  label={"Promo Code"}
                  value={promoValue}
                  onChange={onChangePromo}
                  isDisabled = {isCheckDisabled}
                />
              </Grid>

              <Grid item xs={4}>
                <ButtonComponent
                  name={"Check"}
                  variant="contained"
                  onClick={onClickCheck}
                  disabled={isCheckDisabled}
                />
              </Grid>
            </Grid>
          </Box>
          {isDiscount ? (
            <Box sx={{ display: "flex" }}>
              {_.get(promotion, "type_name") == "percentage" ? (
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  fontFamily={"Source Sans Pro"}
                >
                  You have recived a discount of {_.get(promotion, "value")}%
                </Typography>
              ) : null}

              {_.get(promotion, "type_name") == "flat" ? (
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  fontFamily={"Source Sans Pro"}
                >
                  You have recived a discount of ${_.get(promotion, "value")}
                </Typography>
              ) : null}
            </Box>
          ) : null}

          <Box
            sx={{
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: "#B3B3B3",
              borderRadius: 2,
              bgcolor: "white",
              p: 1,
            }}
          >
            <Typography
              fontFamily={"Source Sans Pro"}
              variant="subtitle1"
              textAlign={"center"}
            >
              Estimated Shipping cost
            </Typography>
            <Typography
              fontFamily={"Source Sans Pro"}
              variant="subtitle1"
              textAlign={"center"}
            >
              ${roundToDecimalPlace(shippingCost, 2)}
            </Typography>
          </Box>

            <Box>
                 <DropdownComponent
                    label="Shipping To"
                    value={addressId}
                    dropdownList={addressList}
                    disabled={false}
                    onChange={onChangeAddress}
                  />
                {addressId > -1 ? (<>
                  <br/>
                  <AddressCard
                    item={addressDetails}
                    showBackBtn={false}
                    showRadio={false}
                    isEditable={false}
                  />
                </>) : null}      
            </Box>
            <Box>
                   <Grid item>
                      <Grid container alignItems={"center"}>
                        <Grid item>
                          <CheckboxComponent
                            checked={checkTerms}
                            inputProps={{ "aria-label": "controlled" }}
                            onChange={handleChangeTermsCheckbox}
                          />
                        </Grid>
                        <Grid item>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              color: useTheme().palette.grey[500],
                              fontFamily: "Source sans pro",
                              fontWeight: 600,
                            }}
                          >
                            I agree to the{" "}
                            <a href="/terms-and-conditions" target="_blank" style={{textDecoration:'none'}}> <span className="hightlighted-text">Terms & Conditions</span></a>.
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid item>
                            <img src={IMAGES?.LOGO?.PAYMENT_SOLUTIONS} width="100%"/>
                      </Grid>
                    </Grid>
            </Box>
          <Box>
            <ButtonComponent
              size="large"
              variant="contained"
              name={shipBtnName}
              width={"100%"}
              onClick={handleShipmentSubmit}
              disabled={shipBtnIsDisabled}
            />
          </Box>
        </Stack>
      </Container>
    </Card>
  );
};
